import { FontStyle } from './enums';
import styles from './styles.scss';

export const getClassForFontStyle = (fontStyle: FontStyle) => styles[fontStyle];
